import { render, staticRenderFns } from "./printtreatment.vue?vue&type=template&id=641e2b4c&"
import script from "./printtreatment.vue?vue&type=script&lang=js&"
export * from "./printtreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports